// json文件的请求缓存
const jsonCache: Map<string, [Blob | null, object]> = new Map()

/**
 * 从vap/MP4文件中获取json信息(带MP4文件数据blob)
 * @param vapUrl 文件URL
 * @param startIndex 文件文本遍历开始索引
 * @param maxLength 限制遍历最大次数
 * @returns json对象
 */
export const getVapJsonInfo = (
  vapUrl: string,
  startIndex: number = 0,
  maxLength: number = 20000
): Promise<[Blob, object]> => {
  return new Promise((resolve, reject) => {
    const jsonValue = jsonCache.get(vapUrl)
    // 如果有缓存到json值，则直接返回
    if (jsonValue) {
      resolve(jsonValue as [Blob, object])
      return
    }
    console.time('请求vap/MP4时间')
    // 请求vap文件，尝试获取json配置信息
    $fetch(vapUrl, { method: 'GET', responseType: 'blob' })
      .then((res) => {
        const blob = res as Blob
        blob.text().then((text) => {
          const targetStr = 'vapc' // 目标字符串，出现该字符串表示有json配置信息
          const targetStrLength = targetStr.length
          let i = 0 // 遍历目标字符串索引
          let jsonStr = '' // json字符串
          const symbolCountMap = { '{': 0, '[': 0 }
          const setSymbolCount = (str: string) => {
            const map: Record<string, undefined | (() => void)> = {
              '{': () => {
                symbolCountMap['{']++
              },
              '}': () => {
                symbolCountMap['{']--
              },
              '[': () => {
                symbolCountMap['[']++
              },
              ']': () => {
                symbolCountMap['[']--
              }
            }
            const action = map[str]
            action && action()
          }
          console.timeEnd('请求vap/MP4时间')
          console.time('遍历获取json时间')
          for (let index = startIndex; index < text.length; index++) {
            // 没有获取到json信息
            if (index > startIndex + maxLength) {
              throw new Error(
                `当前vap遍历的部分没有json信息，可更改当前的配置信息: { startIndex: ${startIndex}, maxLength: ${maxLength} }`
              )
            }
            const str = text[index]
            // 可开始获取json信息
            if (i === targetStrLength) {
              jsonStr += str
              setSymbolCount(str)
              // json信息获取完毕
              if (symbolCountMap['['] === 0 && symbolCountMap['{'] === 0) {
                console.log(
                  `获取vap/MP4配置信息成功，当前遍历次数: ${index}/${text.length}; 当前json字符串长度: ${jsonStr.length};
                  vap最佳配置信息为 { startIndex: ${index - jsonStr.length - targetStrLength + 1}, maxLength: ${jsonStr.length + targetStrLength - 1} },
                  当前配置信息为 { startIndex: ${startIndex}, maxLength: ${maxLength} }`
                )
                console.timeEnd('遍历获取json时间')
                try {
                  const json = JSON.parse(jsonStr)
                  // 缓存json信息
                  jsonCache.set(vapUrl, [blob, json])
                  // 返回json信息
                  resolve([blob, json])
                } catch (error) {
                  console.log('获取vap/MP4配置信息错误', error)
                  reject(error)
                }
                break
              }
              continue
            }
            // 还没遍历到目标字符串
            if (targetStr[i] === str) {
              i++
            } else {
              i = 0
            }
          }
          reject()
        })
      })
      .catch(reject)
  })
}

/**
 * 从vap/MP4文件中获取json信息(请求类型text，兼容部分iOS播放失败，没搞懂为什么部分iOS用这个方法会播放失败)
 * @param vapUrl 文件URL
 * @param startIndex 文件文本遍历开始索引
 * @param maxLength 限制遍历最大次数
 * @returns json对象
 */
export const getVapJsonInfoRequestText = (
  vapUrl: string,
  startIndex: number = 0,
  maxLength: number = 20000
): Promise<[null, object]> => {
  return new Promise((resolve, reject) => {
    const jsonValue = jsonCache.get(vapUrl)
    // 如果有缓存到json值，则直接返回
    if (jsonValue) {
      resolve(jsonValue as [null, object])
      return
    }
    console.time('请求vap/MP4时间')
    // 请求vap文件，尝试获取json配置信息
    $fetch(vapUrl, { method: 'GET', responseType: 'text' })
      .then((res) => {
        const data = res as string
        const targetStr = 'vapc' // 目标字符串，出现该字符串表示有json配置信息
        const targetStrLength = targetStr.length
        let i = 0 // 遍历目标字符串索引
        let jsonStr = '' // json字符串
        const symbolCountMap = { '{': 0, '[': 0 }
        const setSymbolCount = (str: string) => {
          const map: Record<string, undefined | (() => void)> = {
            '{': () => {
              symbolCountMap['{']++
            },
            '}': () => {
              symbolCountMap['{']--
            },
            '[': () => {
              symbolCountMap['[']++
            },
            ']': () => {
              symbolCountMap['[']--
            }
          }
          const action = map[str]
          action && action()
        }
        console.timeEnd('请求vap/MP4时间')
        console.time('遍历获取json时间')
        for (let index = startIndex; index < data.length; index++) {
          // 没有获取到json信息
          if (index > startIndex + maxLength) {
            throw new Error(
              `当前vap遍历的部分没有json信息，可更改当前的配置信息: { startIndex: ${startIndex}, maxLength: ${maxLength} }`
            )
          }
          const str = data[index]
          // 可开始获取json信息
          if (i === targetStrLength) {
            jsonStr += str
            setSymbolCount(str)
            // json信息获取完毕
            if (symbolCountMap['['] === 0 && symbolCountMap['{'] === 0) {
              console.log(
                `获取vap/MP4配置信息成功，当前遍历次数: ${index}/${data.length}; 当前json字符串长度: ${jsonStr.length};
                vap最佳配置信息为 { startIndex: ${index - jsonStr.length - targetStrLength + 1}, maxLength: ${jsonStr.length + targetStrLength - 1} },
                当前配置信息为 { startIndex: ${startIndex}, maxLength: ${maxLength} }`
              )
              console.timeEnd('遍历获取json时间')
              try {
                const json = JSON.parse(jsonStr)
                // 缓存json信息
                jsonCache.set(vapUrl, [null, json])
                // 返回json信息
                resolve([null, json])
              } catch (error) {
                console.log('获取vap/MP4配置信息错误', error)
                reject(error)
              }
              break
            }
            continue
          }
          // 还没遍历到目标字符串
          if (targetStr[i] === str) {
            i++
          } else {
            i = 0
          }
        }
        reject()
      })
      .catch(reject)
  })
}

/**
 * 从json文件中获取json信息
 * @param jsonUrl json文件URL
 * @param vapUrl vap/MP4文件URL
 * @returns json对象
 */
export const getJsonInfoByFile = (
  jsonUrl: string,
  vapUrl: string
): Promise<[Blob | null, object]> => {
  return new Promise((resolve, reject) => {
    const value = jsonCache.get(vapUrl)
    if (value) {
      resolve(value)
    } else {
      $fetch(vapUrl, { method: 'GET' })
        .then((res) => {
          const { status, data } = res as { status: number; data: {} }
          if (status === 200) {
            jsonCache.set(vapUrl, [null, data])
            resolve([null, data])
          } else {
            reject()
          }
        })
        .catch(reject)
    }
  })
}

/**
 * blob 转 url
 * @param blob mp4数据
 */
export const blobToUrl = (blob: Blob) => {
  const URL = window.webkitURL || window.URL
  return new Promise<string>((resolve) => {
    if (/iphone|ipad|ipod/i.test(navigator.userAgent)) {
      const fileReader = new FileReader()

      fileReader.onloadend = function () {
        const resultStr = fileReader.result as string
        const raw = atob(resultStr.slice(resultStr.indexOf(',') + 1))
        const buf = Array(raw.length)

        for (let d = 0; d < raw.length; d++) {
          buf[d] = raw.charCodeAt(d)
        }

        const arr = new Uint8Array(buf)
        const blob = new Blob([arr], {
          type: 'video/mp4'
        })
        resolve(URL.createObjectURL(blob))
      }

      fileReader.readAsDataURL(blob)
    } else {
      resolve(URL.createObjectURL(blob))
    }
  })
}

// /**
//  * 清除json缓存
//  */
// export const clearJsonCache = () => {
//   jsonCache.clear();
// };
